import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { Typography, Button, Spinner } from "@material-tailwind/react";
import { add_sticker_data, update_sticker, get_sticker_Tags, add_sticker_Tags } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { FileInput } from '../../Components/FileInput/FileInput'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '../Switch/Switch';
import moment from 'moment';


export const StickerModal = () => {
    const { truncateString, isModalLoading, setFormData, setDeleteUpdateTag, deleteUpdateYes, handleSwitch, handleFileInput, setIsModalLoading, handleClose, formData, open, addEditDeleteTag } = useContext(NewContext);

    const [selectedValues, setSelectedValues] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [stickerPriority, setStickerPriority] = useState({});
    const [selectedPriorityValues, setSelectedPriorityValues] = useState({});


    const getStickerTags = async () => {
        const getStickerData = await get_sticker_Tags();
        const options = getStickerData.data.filter((item) => item.isActive == true).map((item) => ({
            value: item.name,
            label: item.name,
        }));
        setApiData(options);

        const newOption = Array(getStickerData.totalStickerData).fill(0).map((item, i) => ({
            value: i + 1,
            label: i + 1,
        }))

        setStickerPriority(newOption)

        const selectedFromFormData = formData?.tag || [];
        let newArray = []
        selectedFromFormData.filter((selectedItem) => {
            const newObject = {
                value: selectedItem,
                label: selectedItem
            }
            newArray.push(newObject)
        });
        setSelectedValues(newArray);

        const newObject1 = {
            value: formData?.priority,
            label: formData?.priority
        }

        setSelectedPriorityValues(newObject1)

    }

    useEffect(() => {
        getStickerTags()
    }, [formData?.tag])

    const handleSelectChange = async (newValue, actionMeta) => {
        setSelectedValues(newValue);
        const newObject = {
            name: actionMeta.option.value,
            isActive: true
        }
        await add_sticker_Tags(newObject)
    };

    const handleSelectSingleChange = async (newValue) => {
        setSelectedPriorityValues(newValue)
    };


    useEffect(() => {
        if (addEditDeleteTag === `add`) setFormData({ ...formData, isActive: true })
    }, [addEditDeleteTag]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdateSounds;
        setIsModalLoading(true);

        const getSelectedValue = selectedValues.map((item) => item.value);
        const obj = {
            tag: getSelectedValue,
            stickerPreview: formData?.stickerPreview ? formData?.stickerPreview : [],
            isActive: formData?.isActive ? true : false,
            isPremium: formData?.isPremium ? true : false,
        }
        if (selectedPriorityValues.value) {
            obj.priority = selectedPriorityValues.value
        }
        if (addEditDeleteTag == `update`) {
            createUpdateSounds = await update_sticker(obj, formData?._id)
        } else {
            createUpdateSounds = await add_sticker_data(obj)
        }

        setIsModalLoading(false);
        if (createUpdateSounds) {
            const { message, status } = createUpdateSounds;
            if (status) {
                toast.success(message);
                handleClose();
                setDeleteUpdateTag(deleteUpdateYes);
                setSelectedValues([]);
            } else {
                toast.error(message);
            };
        }
    }
    useEffect(() => {
        if (addEditDeleteTag === `add`) {
            setSelectedPriorityValues({})
            setSelectedValues([])
        }

    }, [open])

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "490px",
                            borderRadius: "12px" // Set your width here
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Sticker ` : `Add Sticker `
                    }

                </DialogTitle>

                <DialogContent>
                    <div>
                        {
                            <form onSubmit={handleSubmit}>
                                {
                                    addEditDeleteTag === 'update' ? <div className="">
                                        <label htmlFor="stickerPreview" className="block text-sm font-medium leading-6 text-gray-900">Last update : {moment(formData?.updatedAt).format('DD/MM/YYYY,hh:mm A')}</label>
                                        <Typography className="text-lg text-[#1E1627] font-medium">Preview :</Typography>
                                        <div className='w-auto'>
                                            <FileInput name={`stickerPreview`} imgClass={`h-full`} previewFields={'preview'} accept={'image/*'} validation={false} acceptedExtensions={/\.(jpg|png|webp|PNG)$/} />
                                        </div>
                                    </div> : null
                                }

                                <div className="grid grid-cols-6 lg:grid-cols-6 gap-5 add-edit-form">
                                    {
                                        addEditDeleteTag === `add` ? <div className="col-span-6 sm:col-span-6">
                                            <label htmlFor="stickerPreview" className="block text-sm font-medium leading-6 text-gray-900"> <p>Upload Stickers <sup className='text-red-600'>*</sup> :</p> </label>
                                            <div className="mt-1.5 relative">
                                                {
                                                    addEditDeleteTag === 'update' ?
                                                        <input id='stickerPreview' type='file' accept="image/png, image/jpeg , image/webp" name='stickerPreview' onChange={e => handleFileInput(e)} className='w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' multiple /> :
                                                        <input id='stickerPreview' type='file' accept="image/png, image/jpeg , image/webp" name='stickerPreview' onChange={e => handleFileInput(e)} className='w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' multiple required />
                                                }
                                                {
                                                    addEditDeleteTag === `update` && formData.preview && typeof formData.preview === 'string' && !formData.stickerPreview &&
                                                    <label htmlFor="stickerPreview" className='absolute sm:left-[36%] left-[33.5%] right-[2px] w-auto rounded-r-[7px] border-1 border-white text-sm leading-none bg-white h-[90%] top-0 bottom-0 m-auto flex items-center pl-1'>{truncateString(formData.preview.split('/')[formData.preview.split('/').length - 2], 24)}</label>
                                                }
                                            </div>
                                        </div> : null
                                    }


                                    <div className="mt-2 col-span-6 sm:col-span-6">
                                        <label htmlFor="categories" className="block text-sm font-medium leading-6 text-gray-900 -z-10">Tag:</label>
                                        <div className="my-1.5 tag-multiselect">
                                            <CreatableSelect
                                                isMulti
                                                options={apiData} // Use mapped API data as options
                                                onChange={handleSelectChange} // Attach the onChange event handler
                                                value={selectedValues}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-2 col-span-6 sm:col-span-6">
                                        <label htmlFor="categories" className="block text-sm font-medium leading-6 text-gray-900 -z-10">Priority:</label>
                                        <div className="my-1.5 tag-multiselect">
                                            {/* <CreatableSelect
                                                options={stickerPriority} // Use mapped API data as options
                                            // onChange={handleSelectChange} // Attach the onChange event handler
                                            // value={selectedValues}
                                            /> */}
                                            <Select
                                                value={selectedPriorityValues}
                                                onChange={handleSelectSingleChange}
                                                options={stickerPriority}
                                            />
                                        </div>
                                    </div>



                                    <div className="col-span-2 sm:col-span-2">
                                        <label htmlFor="isPremium" className="block text-sm font-medium leading-6 text-gray-900">Premium:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isPremium' name='isPremium' onChange={handleSwitch} checked={formData?.isPremium} />
                                        </div>
                                    </div>

                                    <div className="col-span-2 sm:col-span-2">
                                        <label htmlFor="isActive" className="block text-sm font-medium leading-6 text-gray-900">Active:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isActive' name='isActive' onChange={handleSwitch} checked={formData?.isActive} />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex justify-end mt-5'>
                                    <Button
                                        onClick={handleClose}
                                        className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                    >
                                        <span>Cancel</span>
                                    </Button>
                                    <Button
                                        disabled={isModalLoading}
                                        className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                        type='submit'
                                    >
                                        {isModalLoading && <Spinner className="h-4 w-4" />}
                                        <span className={isModalLoading ? 'ml-4' : ''}>{addEditDeleteTag === `update` ? `Update` : `Add`}</span>
                                    </Button>
                                </div>
                            </form>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default StickerModal
